import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'sas-erp-theme';
const ThemeModeContext = createContext({ mode: 'light', toggleTheme: () => {} });

function getInitialMode() {
  const savedMode = localStorage.getItem(STORAGE_KEY);
  if (savedMode === 'light' || savedMode === 'dark') return savedMode;

  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function useThemeMode() {
  return useContext(ThemeModeContext);
}

export default function ThemeModeProvider({ children }) {
  const location = useLocation();
  const [mode, setMode] = useState(getInitialMode);
  const effectiveMode = location.pathname === '/login' ? 'light' : mode;

  useEffect(() => {
    document.documentElement.dataset.theme = effectiveMode;
    document.documentElement.style.colorScheme = effectiveMode;
  }, [effectiveMode]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, mode);
  }, [mode]);

  const value = useMemo(() => ({
    mode: effectiveMode,
    toggleTheme: () => setMode((current) => current === 'light' ? 'dark' : 'light'),
  }), [effectiveMode]);

  return (
    <ThemeModeContext.Provider value={value}>
      {children}
    </ThemeModeContext.Provider>
  );
}
